import { configureStore } from '@reduxjs/toolkit';

import browserUtils from './slices/browserUtils';
import data from './slices/data';

const store = configureStore({
  reducer: {
    browserUtils: browserUtils.reducer,
    data: data.reducer,
  },
});

export default store;
